// @flow
import configure from './configure';
import type { Auth } from './modules/auth';
import type { User } from './modules/user';
import type { Base } from './modules/base';
import type { Write } from './modules/write';
import type { Posts } from './modules/posts';
import type { Products } from './modules/products';
import type { Banners } from './modules/banners';
import type { Brands } from './modules/brands';
import type { Events } from './modules/events';
import type { Letters } from './modules/letters';
import type { Quotes } from './modules/quotes';
import type { Partners } from './modules/partners';
import type { Sample } from './modules/sample';
import type { Listing } from './modules/listing';
import type { Display } from './modules/display';
import type { Bannering } from './modules/bannering';
import type { Branding } from './modules/branding';
import type { Eventing } from './modules/eventing';
import type { Lettering } from './modules/lettering';
import type { Quoting } from './modules/quoting';
import type { Partnering } from './modules/partnering';
import type { ProfileState } from './modules/profile';
import type { FollowState } from './modules/follow';
import type { CommonState } from './modules/common';
import type { SettingsState } from './modules/settings';
import type { SearchState } from './modules/search';
import type { SeriesState } from './modules/series';
import type { Cart } from './modules/cart';
import type { Wish } from './modules/wish';
import type { Orders } from './modules/orders';

const store = configure(typeof window === 'undefined' ? undefined : window.__REDUX_STATE__);

export default store;

export type State = {
  auth: Auth,
  user: User,
  base: Base,
  write: Write,
  posts: Posts,
  products: Products,
  banners: Banners,
  brands: Brands,
  events: Events,
  letters: Letters,
  quotes: Quotes,
  partners: Partners,
  sample: Sample,
  listing: Listing,
  display: Display,
  bannering: Bannering,
  branding: Branding,
  eventing: Eventing,
  lettering: Lettering,
  quoting: Quoting,
  partnering: Partnering,
  profile: ProfileState,
  follow: FollowState,
  common: CommonState,
  settings: SettingsState,
  search: SearchState,
  series: SeriesState,
  cart: Cart,
  wish: Wish,
  orders: Orders,
  pender: {
    pending: any,
    success: any,
    failure: any,
  },
};



// WEBPACK FOOTER //
// ./src/store/index.js